export default __webpack_public_path__ + "static/media/promo-harry-in-hiding_00.944cec9f.jpg";